<template>
  <div>
    <SectionHeader v-if="content.header" :text="content.header" v-reveal />
    <h2 class="title" v-reveal="{ delay: 200 }">{{ content.title }}</h2>
    <p v-if="content.description" class="description" v-reveal="{ delay: 200 }">
      {{ content.description }}
    </p>
  </div>
</template>

<script>
import { SectionHeader } from '@/components/small'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'HeadingBlock',
  mixins: [DefaultSectionProps],
  components: { SectionHeader },
}
</script>
